export default __webpack_public_path__ + "static/media/carbon_phone.1936cc17.svg";